var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donation_content"},[_c('img',{staticClass:"donation_content_img",attrs:{"src":_vm.returnImage()}})])
}
var staticRenderFns = []

export { render, staticRenderFns }